import { render, staticRenderFns } from "./ItemAuthorSaveSpinner.vue?vue&type=template&id=d129a144"
import script from "./ItemAuthorSaveSpinner.vue?vue&type=script&lang=js"
export * from "./ItemAuthorSaveSpinner.vue?vue&type=script&lang=js"
import style0 from "./ItemAuthorSaveSpinner.vue?vue&type=style&index=0&id=d129a144&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports